import React, { Component } from 'react';
import { WithKeyboardChange } from '@platform/base';
import { isArrowKeyDown, ViewModel } from '@platform/api';
import classnames from 'classnames';

const { createKeyMap, processCursorPointInSide } = WithKeyboardChange;
const { keyByModuleId } = createKeyMap;

let preventDefaultKeys = new Set([13, 38, 40]);

export default function useHotKey(Table) {
    return class HotKeyTable extends Component {
        render() {
            let { store, flex, id, hotKeyWithEnter } = this.props;
            return <div 
                className={classnames("table-hotkey-wrapper", { 'flex-container': flex })} 
                id={`hot-key-${id}`}
                onKeyDownCapture={event => {
                    if (!event.currentTarget.contains(event.target)) {
                        return;
                    }

                    let { 
                            getFocusedCell, 
                            focusOnCell, 
                            setSelectedCell, 
                            getStatus, 
                            getCheckedKeys, 
                        } = store,
                        focusedCell = getFocusedCell();
                
                    console.log('keydown', focusedCell);

                    if (focusedCell.rowKey && focusedCell.colKey) {
                        let key = event.keyCode || event.charCode || event.which;
                        let { rowKey, colKey } = focusedCell, 
                            moveResult;
                            
                        if ([37, 39].includes(key)) {
                            if (!isArrowKeyDown(event, [37, 39])) return; // 有shift等特殊键
                            if (event.target.value) {
                                let cursorInStartOrEnd = false;
                                processCursorPointInSide(() => { cursorInStartOrEnd = true; }, event);
                                if (!cursorInStartOrEnd) return; // 光标不在开头或者结尾
                            }
                            event.preventDefault();
                        }

                        preventDefaultKeys.has(key) && event.preventDefault();

                        switch (key) {
                            // tab
                            case 9:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: event.shiftKey ? -1 : 1, loop: false });
                                if (moveResult) {
                                    event.preventDefault();
                                } else {
                                    event.preventDefault();
                                    hotKeyWithEnter({ e: event, moduleId: id, ViewModel });
                                }
                                break;
                            // enter
                            case 13:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: event.shiftKey ? -1 : 1, loop: false });
                                if (moveResult) {
                                    event.preventDefault();
                                } else {
                                    hotKeyWithEnter({ e: event, moduleId: id, ViewModel });
                                }
                                break;
                            // space
                            case 32:
                                if (getStatus() === 'browse') {
                                    event.stopPropagation();
                                    event.preventDefault();
                                    let checkedKeys = getCheckedKeys(),
                                        { checkboxConfig } = this.props,
                                        isChecked;

                                    if (checkedKeys.has(rowKey)) {
                                        checkedKeys.delete(rowKey);
                                        isChecked = false;
                                    } else {
                                        checkedKeys.add(rowKey);
                                        isChecked = true;
                                    }
                                    
                                    checkboxConfig?.onCheck?.(rowKey, { isChecked, checkedKeys });
                                }
                                break;
                            // left
                            case 37:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: -1 });
                                break;
                            // top
                            case 38:
                                event.stopPropagation();
                                if (event.shiftKey) {
                                    // 跳到上一个区域第一个可编辑字段
                                    console.log(keyByModuleId);
                                } else {
                                    moveResult = store.moveTo(rowKey, colKey, { bottom: -1 });
                                }
                                break;
                            // right
                            case 39:
                                event.stopPropagation();
                                moveResult = store.moveTo(rowKey, colKey, { right: 1 });
                                break;
                            // bottom
                            case 40:
                                event.stopPropagation();
                                if (event.shiftKey) {
                                    // 跳到下一个区域第一个可编辑字段
                                    console.log(keyByModuleId);
                                } else {
                                    moveResult = store.moveTo(rowKey, colKey, { bottom: 1 });
                                }
                                break;
                            default:
                                break;
                        }
                        if (moveResult) {
                            setSelectedCell(new Map());
                            focusOnCell(moveResult.rowKey, moveResult.colKey);
                        }
                    }
                
                }}>
                <Table {...this.props}></Table>
            </div>;
        }
    };
}

useHotKey.displayName = 'useHotKey';
useHotKey.dependence = [];
useHotKey.hooks = function(){
    return {
        copy: content => {
            if(window.isSecureContext) {
                // navigator方式
                if(navigator?.clipboard?.writeText){ //支持navigator的浏览器 chrome
                    navigator.clipboard.writeText(content).then(function(){
                        // console.log('navigator复制');
                    });
                } else if(window.clipboardData){ //不支持navigator的但支持clipboardData的 IE
                    window.clipboardData.setData('Text', content);
                    // console.log('clipboard复制');
                }
                // TODO Edge
            } else {
                // 创建text area
                let textArea = document.createElement("textarea");
                textArea.value = content;
                // 使text area不在viewport，同时设置不可见
                textArea.style.position = "absolute";
                textArea.style.opacity = 0;
                textArea.style.left = "-999999px";
                textArea.style.top = "-999999px";
                document.body.appendChild(textArea);
                textArea.focus({ preventScroll: true });
                textArea.select();
                document.execCommand('copy');
                textArea.remove();
            }
        },
    };
};